import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { getJsmSesameBaseUrl } from '@atlassian/jira-servicedesk-incident-management-common/src/utils.tsx';
import type { EmailTemplate, ContainerProps, State } from '../../types.tsx';

export const getEmailTemplate =
	(templateId: string): Action<State, ContainerProps> =>
	async ({ getState, setState }, { cloudId }) => {
		const { emailTemplate } = getState();

		if (emailTemplate.loading) {
			return;
		}

		setState({
			emailTemplate: {
				...emailTemplate,
				loading: true,
				error: undefined,
			},
		});

		try {
			const response: EmailTemplate = await fetchJson(
				`${getJsmSesameBaseUrl(cloudId)}/v1/stakeholders/template/${templateId}`,
			);

			setState({
				emailTemplate: {
					data: response,
					loading: false,
					error: undefined,
				},
			});
		} catch (e: unknown) {
			setState({
				emailTemplate: {
					data: undefined,
					loading: false,
					error: { value: e instanceof Error ? e.message : 'Unknown error' },
				},
			});
		}
	};

export const resetEmailTemplate =
	(): Action<State, ContainerProps> =>
	({ setState }) => {
		setState({
			emailTemplate: {
				data: undefined,
				loading: false,
				error: undefined,
			},
		});
	};
